import WarehouseCloud from '../Objects/Warehouses/WarehouseCloud'
import MenuContext from 'context/menu/MenuContext'
import { useContext, RefObject } from 'react'

const useObjectHover = (
  typeId: string
) => {
  const showMenu = useContext(MenuContext)

  const generateHover = (object: HTMLElement) => {
    showMenu(<WarehouseCloud
      object={object}
      typeId={typeId}
    />)
  }

  const onHover = (objectRef: RefObject<HTMLElement>) => {
    const object = objectRef.current
    if (!object) return

    const onLeave = () => {
      object.removeEventListener('mouseleave', onLeave)
      showMenu()
    }

    setTimeout(() => {
      if (object) {
        generateHover(object)
        object.addEventListener('mouseleave', onLeave)
      }
    })
  }

  return {
    onHover,
    generateHover,
  }
}

export default useObjectHover
